import { render, staticRenderFns } from "./GridBase.vue?vue&type=template&id=d52bf7e8&"
import script from "./GridBase.vue?vue&type=script&lang=js&"
export * from "./GridBase.vue?vue&type=script&lang=js&"
import style0 from "./GridBase.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports